interface UseFileManagerToolbarProps {
  toolbarClick?: Function;
  setFilesViewMode?: Function;
}

function useFileManagerToolbar({ toolbarClick = () => {}, setFilesViewMode = () => {} }: UseFileManagerToolbarProps) {
  const handleToolBtnClick = (e: any, id: string) => {
    e.stopPropagation();
    toolbarClick(e, id);
  };

  const handleOptionsViewClick = (args: any) => {
    setFilesViewMode(args.item.id);
  };

  return {
    handleToolBtnClick,
    handleOptionsViewClick,
  };
}

export default useFileManagerToolbar;
